import DataUploadController from "../../services/classes/DataUploadController";
import {matHttp} from "../../stores/init";

export const contractFileMimeTypes = 'application/pdf';
export const contractFileIsValid: (file: File) => boolean = () => true

export const ContractUploadController = new DataUploadController(matHttp, '/contract/bucket_access_token/');
